export default "__VITE_ASSET__m1jqRS_0__"